module.exports = __webpack_public_path__ + "img/3.7cc05a96.png";